import { Link } from "react-router-dom";
import { mainSiteUrl } from "@/mocks/categories";

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[620px] md:min-h-[750px] flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20editorial%20flat%20lay%20of%20various%20sneakers%20hoodies%20caps%20and%20streetwear%20accessories%20scattered%20dynamically%20on%20a%20textured%20dark%20grey%20concrete%20surface%20dramatic%20side%20lighting%20from%20a%20large%20window%20deep%20shadows%20high%20contrast%20warm%20accent%20tones%20on%20product%20details%20moody%20sophisticated%20aesthetic%20fashion%20editorial%20photography&width=1800&height=900&seq=hero-bg-v3-kakobuy&orientation=landscape"
          alt="Kakobuy Spreadsheet collection of sneakers and streetwear products"
          className="w-full h-full object-cover object-top"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/35 to-black/15"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-8 py-20 md:py-0">
        <div className="max-w-2xl">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-background-50/15 backdrop-blur-sm border border-background-50/20 mb-6">
            <span className="w-2 h-2 rounded-full bg-accent-400 animate-pulse"></span>
            <span className="text-background-50/90 text-xs md:text-sm font-medium">Updated Weekly &bull; 2026 Edition</span>
          </div>

          <h1 className="font-heading text-4xl sm:text-5xl md:text-6xl font-bold text-background-50 leading-tight">
            The Most Trusted<br />
            <span className="text-primary-300">Kakobuy Spreadsheet</span><br />
            for 2026
          </h1>

          <p className="mt-5 text-background-50/70 text-base md:text-lg leading-relaxed max-w-lg">
            Browse verified sellers, compare prices, discover trending products, and shop smarter with our updated Kakobuy Spreadsheet resources.
          </p>

          <div className="mt-8 flex flex-col sm:flex-row items-start sm:items-center gap-4">
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold text-sm md:text-base transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              Explore Spreadsheet
              <i className="ri-arrow-right-line"></i>
            </a>
            <Link
              to="/article/kakobuy-buying-guide"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full border border-background-50/40 text-background-50 hover:bg-background-50/10 font-medium text-sm md:text-base transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              Read Buying Guide
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          {/* Trust badges */}
          <div className="mt-10 flex flex-wrap items-center gap-4 md:gap-6">
            {[
              { icon: "ri-checkbox-circle-line", text: "Verified Sellers" },
              { icon: "ri-time-line", text: "Updated Weekly" },
              { icon: "ri-shield-check-line", text: "Safe Shopping" },
            ].map((item) => (
              <span key={item.text} className="flex items-center gap-2 text-background-50/75 text-xs md:text-sm">
                <i className={item.icon}></i>
                {item.text}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}